import 'antd/lib/input/style';
import 'antd/lib/form/style';

export * from 'antd/lib/input';
export { default as Input } from 'antd/lib/input';
